import '@cloudscape-design/global-styles/index.css';
import { Layout } from '../components/layout';
import { useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { BreadcrumbGroup } from '@cloudscape-design/components';
import { DemoContext } from '../components/demo-context';


export default function Demo() {
    const navigate = useNavigate();
    const { path } = useParams();
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const iframeHeight = "100%";
    const demos = useContext(DemoContext);
    const demo = demos.find((demo) => demo.path === path);
    const iframeSrc = `/live-demos/${path}/?embed=true`;

    // rum?.recordPageView('home');
    const breadcrumbs = (
        <BreadcrumbGroup
            onClick={({ detail }) => navigate(detail.href)}
            items={[
                { text: "Demos", href: "/" },
                { text: demo?.name ? `${demo?.name} Details` : "Demo Details", href: `/details/${path}` },
                { text: "Live Demo", href: `/demo/${path}` }
            ]}
        />
    );
    return (
        <Layout breadcrumbs={breadcrumbs}>
            <iframe ref={iframeRef} src={iframeSrc} style={{ width: '100%', height: iframeHeight, border: 'none' }} title='Live Demo' />
        </Layout>
    );
}

